<app-page-list [columns]="columns" [modifyForm]="modifyForm" [isSelectableTable]="true" [editFunction]="onEditFunction" [canUpdate]="true" [queryService]="service.query" [canInsert]="false" [crud]="service" [insertForm]="insertForm" insertFormTitle="punto di campionamento" insertFormSize="full" [filterForm]="filterForm" [visibleColumns]="visibleColumns"
[excelBtnTitle]="'Esporta punti di campionamento scaduti'" [canExport]="true" (modelChange)="buttonExcelClicked()" (myIdEditEventt)="selectedIdCheckBoxx($event)"  [costumEditFunction]="true" [notCheckFilter]="notCheckFilter" [canImport]="true">
    <div filters>
      <app-filters-form [filtroDataValidita]="false" [form]="filters"></app-filters-form>
    </div>
    <div edit-form class="flex flex-column gap-2">    
      <div class="grid">
        <app-card title="Data validità" class="col-6" borderless>
          <app-date-form [form]="modifyForm"></app-date-form>
        </app-card>
      </div>
    </div>
  </app-page-list>